import React, { useEffect, useState } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import Select from "react-select";
import { toast } from "react-toastify";
import {
  BASIC_SETTING_DETAILS,
  BASIC_SETTING_UPDATE,
} from "../../../../services/ApiCalls";
import { catchAsync, checkResponse } from "../../../../utilities/utilies";
import { zodResolver } from "@hookform/resolvers/zod";
import { Controller, useForm } from "react-hook-form";
import { z } from "zod";
import NotificationSetting from "./NotificationSetting";
import { AppSettingSchema, getFormValues, paymentOptions } from "./utilities";

const BasicSetting = () => {
  const [basicSettingData, setBasicSettingData] = useState();
  const [timeZones, setTimeZones] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);
  const handleChange = (option) => {
    setSelectedOption(option);
    setValue("type", option.value);
  };

  const getData = catchAsync(async () => {
    const res = await BASIC_SETTING_DETAILS();
    // console.log(res, "chkres>>>>>>>");
    const options = res?.data?.data?.time?.timeZoneListing.map((zone) => ({
      value: zone.code,
      label: zone.name,
    }));
    // console.log(options, "chkoptions");
    setTimeZones(options);
    const setData = (data) => {
      // just to check the data is coming in arr or not
      //  some time backend will change the response
      // setBasicSettingData(data[0] && data[0]);
      setBasicSettingData(data);
    };
    checkResponse({ res, setData });
  });

  // console.log(basicSettingData, "basic data ");

  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
    setValue,
  } = useForm({
    resolver: zodResolver(AppSettingSchema),
    values: {
      ...getFormValues(basicSettingData),
    },
  });


  const submitHandler = catchAsync(async (data) => {
    console.log(data, "sde-98yp");
    const res = await BASIC_SETTING_UPDATE({
      App_Settings: { ...data, Admin_TimeZone: data.Admin_TimeZone.value },
    });

    checkResponse({ res, showSuccess: true });
  });

  useEffect(() => {
    getData();
  }, []);

  return (
    <>
      <section className="basicSetting py-3 position-relative">
        <Container>
          <Row>
            <Col lg={5} md={5} sm={12} className="my-2">
              <NotificationSetting
                basicSettingData={basicSettingData}
                setBasicSettingData={setBasicSettingData}
              />
            </Col>
            <Col lg={7} md={7} sm={12} className="my-2">
              <div className="cardCstm p-3 border rounded">
                <div className="cardHead m-0 pb-2 d-flex align-items-center justify-content-between gap-10">
                  <h6 className="m-0 fw-sbold themeBlue">Basic Setting</h6>
                </div>
                <div className="cardBody">
                  <Form onSubmit={handleSubmit(submitHandler)}>
                    <Row>
                      <Col md="6" className="my-2">
                        <label htmlFor="" className="form-label m-0 ">
                          Contact Email <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          placeholder="info@delvitPlatform.com"
                          className="form-control"
                          {...register("Admin_Email_Address")}
                        />
                        {
                          <p className="errorColor">
                            {errors?.Admin_Email_Address &&
                              errors.Admin_Email_Address.message}
                          </p>
                        }
                      </Col>
                      <Col md="6" className="my-2">
                        <label htmlFor="" className="form-label m-0 ">
                          Contact Number <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          placeholder="23452345"
                          className="form-control"
                          {...register("Admin_Phone_Number")}
                        />
                        {
                          <p className="errorColor">
                            {errors?.Admin_Phone_Number &&
                              errors.Admin_Phone_Number.message}
                          </p>
                        }
                      </Col>
                      <Col md="6" className="my-2">
                        <label htmlFor="" className="form-label m-0 ">
                          Admin Country <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          placeholder="country"
                          className="form-control"
                          {...register("Admin_Country")}
                        />
                        {
                          <p className="errorColor">
                            {errors?.Admin_Country &&
                              errors.Admin_Country.message}
                          </p>
                        }
                      </Col>
                      <Col md="6" className="my-2">
                        <label htmlFor="" className="form-label m-0 ">
                          Admin Currency <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          placeholder="USD"
                          className="form-control"
                          {...register("Admin_Currency")}
                        />
                        {
                          <p className="errorColor">
                            {errors?.Admin_Currency &&
                              errors.Admin_Currency.message}
                          </p>
                        }
                      </Col>
                      <Col md="6" className="my-2">
                        <label htmlFor="" className="form-label m-0 ">
                          Admin Currency Symbol{" "}
                          <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          placeholder="$"
                          className="form-control"
                          {...register("Admin_Currency_Code")}
                        />
                        {
                          <p className="errorColor">
                            {errors?.Admin_Currency_Code &&
                              errors.Admin_Currency_Code.message}
                          </p>
                        }
                      </Col>
                      {/* <Col md="6" className="my-2">
                        <label htmlFor="" className="form-label m-0 ">
                          Admin Time Zone <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          placeholder="EDT"
                          className="form-control"
                          {...register("Admin_TimeZone")}
                        />
                        {
                          <p className="errorColor">
                            {errors?.Admin_TimeZone &&
                              errors.Admin_TimeZone.message}
                          </p>
                        }
                      </Col> */}
                      {/* <Col lg="6" className="my-2">
                        <label
                          htmlFor=""
                          className="form-label m-0 fw-sbold text-muted ps-2"
                        >
                          Service Type
                        </label>
                        <Select
                          options={options}
                          value={selectedOption}
                          onChange={handleChange}
                        />
                        <p className="errorColor">
                          {errors?.type && errors.type.message}
                        </p>
                      </Col> */}
                      <Col lg="6" className="my-2">
                        <label
                          htmlFor=""
                          className="form-label m-0 fw-sbold text-muted ps-2"
                        >
                          Admin Time Zone
                        </label>
                        <Controller
                          control={control}
                          name="Admin_TimeZone"
                          render={({ field }) => {
                            return <Select {...field} options={timeZones} />;
                          }}
                        />

                        <p className="errorColor">
                          {errors?.Admin_TimeZone &&
                            errors.Admin_TimeZone.message}
                        </p>
                      </Col>
                      <Col md="6" className="my-2">
                        <label htmlFor="" className="form-label m-0 ">
                          Agency Commission(%){" "}
                          <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          placeholder="0"
                          className="form-control"
                          {...register("Agency_Percentage_Commission")}
                        />
                        {
                          <p className="errorColor">
                            {errors?.Agency_Percentage_Commission &&
                              errors.Agency_Percentage_Commission.message}
                          </p>
                        }
                      </Col>
                      <Col md="6" className="my-2">
                        <label htmlFor="" className="form-label m-0 ">
                          Admin Commission(%){" "}
                          <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          placeholder="0"
                          className="form-control"
                          {...register("Admin_Percentage_Commission")}
                        />
                        {
                          <p className="errorColor">
                            {errors?.Admin_Percentage_Commission &&
                              errors.Admin_Percentage_Commission.message}
                          </p>
                        }
                      </Col>
                      <Col md="6" className="my-2">
                        <label htmlFor="" className="form-label m-0 ">
                          Driver Commission(%){" "}
                          <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          placeholder="0"
                          className="form-control"
                          {...register("Driver_Percentage_Commission")}
                        />
                        {
                          <p className="errorColor">
                            {errors?.Driver_Percentage_Commission &&
                              errors.Driver_Percentage_Commission.message}
                          </p>
                        }
                      </Col>
                      <Col md="6" className="my-2">
                        <label htmlFor="" className="form-label m-0 ">
                          Booking Cancellation Charges{" "}
                          <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          placeholder="0"
                          className="form-control"
                          {...register("Booking_cancellation_charges")}
                        />
                        {
                          <p className="errorColor">
                            {errors?.Booking_cancellation_charges &&
                              errors.Booking_cancellation_charges.message}
                          </p>
                        }
                      </Col>
                      {/* <Col md="6" className="my-2">
                        <label htmlFor="" className="form-label m-0 ">
                          Service Charge
                          <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          placeholder="0"
                          className="form-control"
                          {...register("Service_charges")}
                        />
                        {
                          <p className="errorColor">
                            {errors?.Service_charges &&
                              errors.Service_charges.message}
                          </p>
                        }
                      </Col> */}
                      <Col md="6" className="my-2">
                        <label htmlFor="" className="form-label m-0 ">
                          Default Search Radius{" "}
                          <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          placeholder="0"
                          className="form-control"
                          {...register("Default_Search_Radius")}
                        />
                        {
                          <p className="errorColor">
                            {errors?.Default_Search_Radius &&
                              errors.Default_Search_Radius.message}
                          </p>
                        }
                      </Col>
                      <Col md="6" className="my-2">
                        <label htmlFor="" className="form-label m-0 ">
                          Android User App Forced Version{" "}
                          <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          placeholder="1.0"
                          className="form-control"
                          {...register("Android_User_App_Force_Version")}
                        />
                        {
                          <p className="errorColor">
                            {errors?.Android_User_App_Force_Version &&
                              errors.Android_User_App_Force_Version.message}
                          </p>
                        }
                      </Col>
                      <Col md="6" className="my-2">
                        <label htmlFor="" className="form-label m-0 ">
                          Android driver App Forced Version{" "}
                          <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          placeholder="1.0"
                          className="form-control"
                          {...register("Android_Driver_App_Force_Version")}
                        />
                        {
                          <p className="errorColor">
                            {errors?.Android_Driver_App_Force_Version &&
                              errors.Android_Driver_App_Force_Version.message}
                          </p>
                        }
                      </Col>
                      <Col md="6" className="my-2">
                        <label htmlFor="" className="form-label m-0 ">
                          IOS User App Forced Version{" "}
                          <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          placeholder="1.0"
                          className="form-control"
                          {...register("IOS_User_App_Force_Version")}
                        />
                        {
                          <p className="errorColor">
                            {errors?.IOS_User_App_Force_Version &&
                              errors.IOS_User_App_Force_Version.message}
                          </p>
                        }
                      </Col>
                      <Col md="6" className="my-2">
                        <label htmlFor="" className="form-label m-0 ">
                          IOS driver App Forced Version
                          <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          placeholder="1.0"
                          className="form-control"
                          {...register("IOS_Driver_App_Force_Version")}
                        />
                        {
                          <p className="errorColor">
                            {errors?.IOS_Driver_App_Force_Version &&
                              errors.IOS_Driver_App_Force_Version.message}
                          </p>
                        }
                      </Col>
                      <Col md="6" className="my-2">
                        <label htmlFor="" className="form-label m-0 ">
                          Free Miles
                          <span className="text-danger">*</span>
                        </label>
                        <div className="input-group">
                          <input
                            type="text"
                            placeholder="0"
                            className="form-control"
                            {...register("Free_miles")}
                          />
                          <span
                            className="input-group-text"
                            style={{ fontSize: "14px" }}
                          >
                            miles
                          </span>
                        </div>
                        {
                          <p className="errorColor">
                            {errors?.Free_miles && errors.Free_miles.message}
                          </p>
                        }
                      </Col>
                      <Col md="6" className="my-2">
                        <label htmlFor="" className="form-label m-0 ">
                          Weight Limit for Bidding
                          <span className="text-danger">*</span>
                        </label>
                        <div className="input-group">
                          <input
                            type="text"
                            placeholder="0"
                            className="form-control"
                            {...register("VEHICLE_WEIGHT_LIMIT_FOR_BIDDING_REQUEST")}
                          />
                          <span
                            className="input-group-text"
                            style={{ fontSize: "14px" }}
                          >
                            lb
                          </span>
                        </div>
                        {
                          <p className="errorColor">
                            {errors?.VEHICLE_WEIGHT_LIMIT_FOR_BIDDING_REQUEST && errors.VEHICLE_WEIGHT_LIMIT_FOR_BIDDING_REQUEST.message}
                          </p>
                        }
                      </Col>
                      <Col md="6" className="my-2">
                        <label htmlFor="" className="form-label m-0 ">
                          Driver Pickup Dropoff Radius
                          <span className="text-danger">*</span>
                        </label>
                        <div className="input-group">
                          <input
                            type="text"
                            placeholder="0"
                            className="form-control"
                            {...register("DRIVER_PICKUP_DROPOFF_RADIUS")}
                          />
                          <span
                            className="input-group-text"
                            style={{ fontSize: "14px" }}
                          >
                            miles
                          </span>
                        </div>
                        {
                          <p className="errorColor">
                            {errors?.DRIVER_PICKUP_DROPOFF_RADIUS && errors.DRIVER_PICKUP_DROPOFF_RADIUS.message}
                          </p>
                        }
                      </Col>
                      <Col md="6" className="my-2">
                        <label htmlFor="" className="form-label m-0 ">
                          Driver Accept Booking Limit
                          <span className="text-danger">*</span>
                        </label>
                        <div className="input-group">
                          <input
                            type="text"
                            placeholder="0"
                            className="form-control"
                            {...register("DRIVER_ACCEPT_BOOKING_COUNT")}
                          />
                         
                        </div>
                        {
                          <p className="errorColor">
                            {errors?.DRIVER_ACCEPT_BOOKING_COUNT && errors.DRIVER_ACCEPT_BOOKING_COUNT.message}
                          </p>
                        }
                      </Col>
                      {/* <Col md="6" className="my-2">
                        <label htmlFor="" className="form-label m-0 ">
                          Per Distance Miles
                          <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          placeholder="0"
                          className="form-control"
                          {...register("Per_distance_miles_price")}
                        />
                        {
                          <p className="errorColor">
                            {errors?.Per_distance_miles_price &&
                              errors.Per_distance_miles_price.message}
                          </p>
                        }
                      </Col> */}
                      <Col md="6" className="my-2">
                        <label htmlFor="" className="form-label m-0 ">
                          Payment Mode <span className="text-danger">*</span>
                        </label>
                        <Controller
                          name="Payment_Mode"
                          control={control}
                          render={({ field }) => (
                            <Select
                              options={paymentOptions}
                              {...field}
                              onChange={(selectedOption) => {
                                field.onChange(selectedOption.value);
                              }}
                              value={paymentOptions.find(
                                (option) => option.value === field.value
                              )}
                            />
                          )}
                        />
                        {
                          <p className="errorColor">
                            {errors?.Payment_Mode &&
                              errors.Payment_Mode.message}
                          </p>
                        }
                      </Col>
                      <Col md="12" className="my-2">
                        <div className="btnWrpper mt-3">
                          <Button
                            className="d-inline-flex align-items-center justify-content-center commonBtn"
                            type="submit"
                          >
                            Submit
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  </Form>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default BasicSetting;
